import { useState } from "react";
import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  Edit,
  Form,
  Input,
  Select,
  useForm,
  useSelect,
} from "@pankod/refine-antd";

import "react-mde/lib/styles/css/react-mde-all.css";

import { IUser } from "interfaces";

export const UserEdit: React.FC<IResourceComponentsProps> = () => {

  const { formProps, saveButtonProps, queryResult } = useForm<IUser>();

  const { selectProps: organizationalUnitSelectProps } = useSelect({
    resource: "organizational-units",
    defaultValue: queryResult?.data?.data.organizational_unit_id || undefined,
    hasPagination: false,
    optionLabel: "name",
    optionValue: "id",
  });
  // Transformar las opciones para mostrar (ID) Nombre
  const transformedSelectProps = {
    ...organizationalUnitSelectProps,
    options: organizationalUnitSelectProps.options?.map((option: any) => ({
      ...option,
      label: `(${option.value}) ${option.label}`,
    })),
  };

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
      <Form.Item
          label="Nombre"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Usuario"
          name="username"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input autoComplete="off"/>
        </Form.Item>
        <Form.Item
          label="Contraseña"
          name="password"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Input type="password" autoComplete="off" />
        </Form.Item>
        <Form.Item
          label="Unidad Académica"
          name="id_organizational_unit"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Select 
            placeholder="Seleccione una unidad académica (opcional)"
            allowClear
            showSearch
            {...transformedSelectProps} 
          />
        </Form.Item>
      </Form>
    </Edit>
  );
};
